import { buildURL } from '../../../helpers/urls';
import { handleResponse } from '../../../helpers/fetch';

// eslint-disable-next-line import/prefer-default-export
export const importFile = (eventIds, file, importMappingFiles = true) => {
  const url = buildURL('/events/import');
  const formData = new FormData();

  formData.append('file', file);
  formData.append('eventIds', JSON.stringify(eventIds));
  formData.append('importMappingFiles', importMappingFiles);

  return fetch(url, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  }).then(handleResponse);
};
